import { render, staticRenderFns } from "./DrugLog.vue?vue&type=template&id=3b3d164d&lang=pug&"
import script from "./DrugLog.vue?vue&type=script&lang=ts&"
export * from "./DrugLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports